/**
 * Connector-health HTTP service (PX-W6.5) — the project-scoped read (ruling
 * R7): plain `@Authenticated` + the project's READ relay gate, answering the
 * NARROW `{provider, status, checkedAt}` projection. No `detail`, no
 * subject/tenant metadata — the page renders what the server sends and
 * nothing wider.
 */

import { apiClient } from '@/services'

import type { ConnectorHealthEntry } from '../types'

export const connectorHealthService = {
  /** One `{provider, status, checkedAt}` row per org credential. */
  forProject(projectId: string): Promise<ConnectorHealthEntry[]> {
    return apiClient.get<ConnectorHealthEntry[]>(
      `/{orgId}/projects/${encodeURIComponent(projectId)}/connectors/health`
    )
  }
}
